export const enumStatus = {
    'INACTIVE': 'Inactif',
    'DONE': 'Fait',
    'REJECTED': 'Disqualifié',
    'NEXT_STEP': 'Etape Suivante',
    'ERROR': 'Erreur'
};
